import t1 from "../../theme_assets/theme1image.jpg";
import t2 from "../../theme_assets/theme2image.jpg";
export interface DocumentTheme {
  id: string;
  title: string;
  titleFont: string;
  bodyFont: string;
  titleColor: string;
  bodyColor: string;
  background?: string;
  backgroundImage?: string; // optional image URL
  headingStyle?: "underline" | "left-accent" | "center-line";
}

export const documentThemes: DocumentTheme[] = [
  {
    id: "default",
    title: "Default Theme",
    titleFont: "Arial, sans-serif",
    bodyFont: "Arial, sans-serif",
    titleColor: "#000000",
    bodyColor: "#000000",
    background: "#FFFFFF",
  },
  {
    id: "1",
    title: "Heritage Serif",
    titleFont: "Georgia, serif",
    bodyFont: "Georgia, serif",
    titleColor: "black",
    bodyColor: "red",

    headingStyle: "center-line",
    backgroundImage: t1,
  },

  {
    id: "2",
    title: "Indigo Accent",
    titleFont: "Segoe UI, sans-serif",
    bodyFont: "Inter, sans-serif",
    titleColor: "#c5d1f1",
    bodyColor: "white",
    headingStyle: "left-accent",
    backgroundImage: t2,
  },

  {
    id: "3",
    title: "Executive Slate",
    titleFont: "Calibri, sans-serif",
    bodyFont: "Calibri, sans-serif",
    titleColor: "#111827",
    bodyColor: "#374151",
    background: "#DCE7F5",
    headingStyle: "underline",
  },
  {
    id: "4",
    title: "Heritage Serif",
    titleFont: "Georgia, serif",
    bodyFont: "Georgia, serif",
    titleColor: "#7C2D12",
    bodyColor: "#44403C",
    background: "#FDF6EC",
    headingStyle: "center-line",
  },

  {
    id: "5",
    title: "Indigo Accent",
    titleFont: "Segoe UI, sans-serif",
    bodyFont: "Inter, sans-serif",
    titleColor: "#1E3A8A",
    bodyColor: "#1F2937",
    background: "#FFFFFF",
    headingStyle: "left-accent",
  },

  {
    id: "6",
    title: "Executive Slate",
    titleFont: "Calibri, sans-serif",
    bodyFont: "Calibri, sans-serif",
    titleColor: "#111827",
    bodyColor: "#374151",
    background:
      "radial-gradient(140% 90% at 50% -10%, rgba(255,255,255,0.85), rgba(0,0,0,0.05)), #f5f1e6",
    headingStyle: "underline",
  },
];
